import React, { FC } from "react";
import { IconType } from "./types";

export const ArrowDown: FC<IconType> = ({
  containerClassNames = "",
  size = 24,
  color = "text-black",
}) => {
  return (
    <div className={"p-1 " + containerClassNames}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        width={size}
        height={size}
        className={"text-black " + color}
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15.75 17.25L12 21m0 0l-3.75-3.75M12 21V3"
        />
      </svg>
    </div>
  );
};
